
import React, { useEffect, useState } from "react";
import { Card, CardBody, CardTitle, Col, Container, Row, Table } from "reactstrap";
import { useParams } from "react-router-dom";

import { Link } from "react-router-dom";
import AdvanceService from "../HRService/AdvanceServices";
import BreadCrumb from "../../../Components/Common/BreadCrumb";



const defData = 
{
  "id": "",
  "transaction_Date": "2023-10-01T05:40:21.1",
  "remarks": "",
  "verified_By": "",
  "total_Amt": 0.00,
  "vmDetail": [
      {
          "id": "",
          "employeeID": 10,
          "employeeName": "",
          "ref_No": "",
          "amount": 0.00,
          "remarks": "",
          "status": 1
      }
  ]
}

const AdvanceDisplay = (props) => {
  // Capture the 'voucherSN' parameter from the URL
  const { id } = useParams();
  console.log(id);
  
  const [employeeDetails, setEmployeeDetails] = useState(defData);


  useEffect(() => {
    // Define an async function to fetch employee details using the 'view' API call
    async function fetchEmployeeDetails() {
      try {
        // Use the 'id' parameter in the API call
        const response = await AdvanceService.view(id);

        // Update the state with the fetched data
        setEmployeeDetails(response); // Assuming this is how you get the data
      } catch (error) {
        console.error('Error fetching employee details:', error);
      }
    }

    // Call the async function to fetch employee details
    fetchEmployeeDetails();
  }, [id]);

//   SwiperCore.use([Autoplay]);



  document.title = 'Profile | Velzon - React Admin & Dashboard Template';

  return (
    

    <React.Fragment>
       <div className="page-content">
      <BreadCrumb title="Advance Records List" pageTitle="Advance Records" />
          <Container fluid>
            <Row>
              <Col lg={12}>
                <Card>
                  <CardBody>
                    <h5 className="card-title mb-3">Info</h5>
                    <div className="table-responsive">
                      <table className="table table-bordered">
                        <tbody>
                        <tr>
                                <th className="ps-0" scope="row">
                                  ID :
                                </th>
                                <td className="text-muted">{employeeDetails.id}</td>
                                </tr>
                                <tr>
                              
                                <th className="ps-0" scope="row">
                                  Transaction_Date:
                                </th>
                                <td className="text-muted">+(1) {employeeDetails.transaction_Date}</td>
                                </tr>
                             
                                <tr>
                                <th className="ps-0" scope="row">
                                 Verified_By :
                                </th>
                                <td className="text-muted">{employeeDetails.verified_By}</td>
                              
                                </tr>
                                <tr>
                                <th className="ps-0" scope="row">
                                  TotalAmount:
                                </th>
                                <td className="text-muted">{employeeDetails.total_Amt}</td>
                                </tr>
                                <tr>
                                <th className="ps-0" scope="row">
                                  Remarks:
                                </th>
                                <td className="text-muted">{employeeDetails.remarks}</td>
                                </tr>
                        </tbody>
                      </table>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
            <Row>
              <Col xl={12}>
                <Card>
                  <CardBody>
                    <h5 className="card-title mb-3">Employee Details</h5>
                    <div className="table-responsive">
                      <Table>
                      <thead>
                            <tr>
                             <th>ID</th>
                             <th>EmployeeName</th>
                              <th>Reference Number</th>
                             <th>Amount</th>
                              <th>Remarks</th>
                              
                              
                              </tr>
                               </thead>
                               <tbody>
  {employeeDetails.vmDetail ? (
    employeeDetails.vmDetail.map((item) => (
      <tr key={item.id}>
        <td>{item.id}</td>
        <td>
  <Link to={`/employee-form/details/${item.id}`}>
    {item.employeeName}
  </Link>
</td>
       
        <td>{item.ref_No}</td>
        <td>{item.amount}</td>
        <td>{item.remarks}</td>
       
        <td>{/* Add action elements here */}</td>
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="7">No data available</td>
    </tr>
  )}
</tbody>
                      </Table>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
   
    </React.Fragment>
  );
};

export default AdvanceDisplay;
